import { useEffect, useRef } from 'react';

import { useSyncContext } from '../../core/sync-context/sync-context';
import { SyncControlDatasourceState } from '../../forecast/detail/reports/datasource-sync/sync-control/types';

/**
 * Hook that triggers a callback when a sync operation completes successfully.
 * Should be used in components that need to refetch data after a sync.
 *
 * Watches `isSyncing` transitions from true → false and checks that the
 * final state is SYNC_COMPLETE (not SYNC_FAILED).
 */
export const useSyncCompleteEffect = (onSyncComplete: () => void | Promise<void>) => {
  const { isSyncing, datasourceState } = useSyncContext();
  const wasSyncing = useRef(false);
  const callbackRef = useRef(onSyncComplete);
  callbackRef.current = onSyncComplete;

  useEffect(() => {
    if (wasSyncing.current && !isSyncing && datasourceState === SyncControlDatasourceState.SYNC_COMPLETE) {
      callbackRef.current();
    }
    wasSyncing.current = isSyncing;
  }, [isSyncing, datasourceState]);
};
